class DynamicScrollHeader {
    constructor() {
        this.header = document.querySelector("header.wp-block-template-part, header");
        this.logoImage = document.querySelector(".wp-block-site-logo img.custom-logo, .wp-block-site-logo img");
        this.logoWrap = document.querySelector(".header__container .wp-block-site-logo");
        this.hoverLogo = window.cmsThemeSettings?.solidHeaderLogo || null;
        this.scrollTrigger = 50;
        this.isHovered = false;
        this.isScrolled = false;
        this.currentLogoState = "original";

        if (!this.header || !this.logoImage || !this.hoverLogo?.url) {
            return;
        }

        this.originalLogo = {
            src: this.logoImage.getAttribute("src") || "",
            srcset: this.logoImage.getAttribute("srcset") || "",
            sizes: this.logoImage.getAttribute("sizes") || "",
        };

        this.preloadLogo(this.hoverLogo.url);
        this.ensureScrollStyles();
        this.events();
        this.handleScroll();
    }

    events() {
        this.header.addEventListener("mouseenter", () => {
            this.isHovered = true;
            this.syncLogoState();
        });

        this.header.addEventListener("mouseleave", () => {
            this.isHovered = false;
            this.syncLogoState();
        });

        window.addEventListener("scroll", () => this.handleScroll(), { passive: true });
    }

    applyHoverLogo() {
        this.setLogo(this.hoverLogo, "solid");
    }

    restoreLogo() {
        this.setLogo(this.originalLogo, "original");
    }

    handleScroll() {
        const wasScrolled = this.isScrolled;
        this.isScrolled = window.scrollY > this.scrollTrigger;

        if (this.isScrolled !== wasScrolled) {
            if (this.isScrolled) {
                this.applyScrolledVisualState();
            } else {
                this.restoreScrolledVisualState();
            }

            this.syncLogoState();
        }
    }

    syncLogoState() {
        if (this.isHovered || this.isScrolled) {
            this.applyHoverLogo();
            return;
        }

        this.restoreLogo();
    }

    setLogo(logo, state) {
        if (this.currentLogoState === state || (!logo?.src && !logo?.url)) {
            return;
        }

        this.currentLogoState = state;
        const src = logo.url || logo.src;

        this.setImageAttribute("src", src);
        this.setOptionalImageAttribute("srcset", logo.srcset);
        this.setOptionalImageAttribute("sizes", logo.sizes);
    }

    setImageAttribute(attribute, value) {
        if (this.logoImage.getAttribute(attribute) !== value) {
            this.logoImage.setAttribute(attribute, value);
        }
    }

    setOptionalImageAttribute(attribute, value) {
        if (value) {
            this.setImageAttribute(attribute, value);
            return;
        }

        if (this.logoImage.hasAttribute(attribute)) {
            this.logoImage.removeAttribute(attribute);
        }
    }

    preloadLogo(src) {
        if (!src) return;

        const image = new Image();
        image.src = src;
    }

    applyScrolledVisualState() {
        this.header.classList.add("dynamic-scroll-solid");

        if (this.logoWrap) {
            this.logoWrap.style.background = "#f5f5f5";
        }
    }

    restoreScrolledVisualState() {
        this.header.classList.remove("dynamic-scroll-solid");

        if (this.logoWrap) {
            this.logoWrap.style.background = "";
        }
    }

    ensureScrollStyles() {
        if (document.getElementById("dynamic-scroll-header-styles")) {
            return;
        }

        const style = document.createElement("style");
        style.id = "dynamic-scroll-header-styles";
        style.textContent = `
      header.dynamic-scroll-solid {
        background-image: none !important;
        background-color: #f5f5f5 !important;
      }

      header.dynamic-scroll-solid a,
      header.dynamic-scroll-solid .mega-menu-link {
        color: #000 !important;
        border-bottom-color: transparent !important;
      }

      header.dynamic-scroll-solid a:hover,
      header.dynamic-scroll-solid a[aria-current="page"],
      header.dynamic-scroll-solid .mega-menu-link:hover,
      header.dynamic-scroll-solid .mega-menu-link[aria-current="page"] {
        color: var(--wp--preset--color--osm-orange, #E8430A) !important;
      }
    `;

        document.head.appendChild(style);
    }
}

export default DynamicScrollHeader;
